import { createContext } from 'react';
import { noop } from 'lodash';

export const ActionContext = createContext({
	isActionOpen: false,
	onOpenChange: noop,
});
